import React from 'react'
import Prop from '../componentes/Prop'
import { ICON_TYPES } from '../constantes/iconos.ts'
import styled from 'styled-components'

const Actividades = () => {
  return (
    <>
      <Prop titulo='NUESTRAS ACTIVIDADES' icono={ICON_TYPES.ACTIVIDADES} />
      <Section>
        <Article>
          <p>En la Fundación Medellín Amigo trabajamos para apoyar a niños escolarizados desde preescolar en su desarrollo académico y emocional. Ofrecemos un espacio seguro y enriquecedor donde los niños pueden realizar sus tareas escolares después del colegio, con el acompañamiento personalizado de un profesor que guía a grupos pequeños de hasta seis estudiantes.

            Además de ayudarles con sus deberes escolares, fortalecemos su aprendizaje mediante prácticas diarias en diversas áreas:
          </p>

          <ul>
            <li>Actitud Matemática</li>
            <li>Lengua Española</li>
            <li>Idiomas Extranjeros</li>
            <li>Ciencias Sociales</li>
          </ul>
          <p>Nuestro enfoque integral incluye acompañamiento psicosocial, para garantizar que cada niño reciba no solo apoyo académico, sino también orientación emocional y social.</p>
          <p>El programa se desarrolla de lunes a jueves, de 12:00 p.m. a 4:00 p.m., en un ambiente que fomenta el aprendizaje, el respeto y el crecimiento personal.
          </p>
          <p>En la Fundación Medellín Amiga, nos dedicamos a ser un puente entre la escuela y el hogar, contribuyendo al desarrollo integral de cada niño y potenciando su futuro.</p>
        </Article>
      </Section>
    </>
  )
}

const Section = styled.section`
  width: 100vw;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
`

const Article = styled.article`
  width: 80%;
  height: max-content;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  background-color: var(--primary);
  padding: 30px;
  border-radius: 20px;
  color: white;
  gap: 20px;
`

export default Actividades